$(document).ready(function() {
    $.validator.addMethod("alpha", function(value, element) {
        return this.optional(element) || value == value.match(/^[a-zA-Z\s]+$/);
    }, "Please enter letters and space only.");
    $.validator.addMethod("e_email", function(value, element) {
        return (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value))?true:false;
    }, "Please enter a valid email address.");

    const contactFormValRule = {
        name: {minlength: 2, alpha: true, required: true, normalizer: function( value ) { return $.trim( value );}},
        email: {e_email: true,required: true},
        phone: {digits: true,required: false},
        message:{required:true}
    };
    function ajaxSubmitErrorCompleteActions(formEleId, alertEleId, ajaxAction = 'submit') {
        if (ajaxAction == 'submit') {
            $(`#${formEleId} button`).attr("disabled", "disabled");
            $(`#${formEleId} button i`).show();
            $(`#${alertEleId}`).hide();
            $(`#${alertEleId} div`).html('');
            $(`#${formEleId} span.text-danger`).html('');
        }

        if (ajaxAction == 'success') {
            $(`#${formEleId} button`).removeAttr('disabled');
            $(`#${formEleId} button i`).hide();
        }

        if (ajaxAction == 'error') {
            $(`#${formEleId} button`).removeAttr('disabled');
            $(`#${formEleId} button i`).hide();
            $(`#${alertEleId}`).show();
            $(`#${alertEleId} div`).html('<p> Something went wrong. Please try again later.</p>');
        }
    }

    var validobj = $('#contact-form').validate({
        errorElement: 'span',
        errorClass: 'text-danger',
        ignore: [],
        //focusInvalid: false,
        rules: {
           ...contactFormValRule,
           cr_hiddenRecaptcha:{required:true}
        },
        highlight: function(element) {
            $(element).removeClass('valid').addClass('is-invalid');
        },
        unhighlight: function(element) {
            $(element).removeClass('is-invalid').addClass('valid');
        },
        success: function(label, element) {
            $(element).removeClass('is-invalid');
            label.remove();
        },
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        submitHandler: function(form) {
            ajaxSubmitErrorCompleteActions('contact-form', 'contact-form-alert');
            $.ajax({
                type     : 'POST',
                url      : $('#contact-form').attr('action'),
                data     : $('#contact-form').serialize(),
                dataType : 'json',
                encode   : true,
                success  : function(data) {
                    ajaxSubmitErrorCompleteActions('contact-form', 'contact-form-alert', 'success');
                    if(data.success){
                        window.location.href = base_url + 'contact-thankyou';
                    } else {
                        $.each(data.message, function(key, value) {
                            $('#contact-form [name=' + key + ']').addClass('is-invalid');
                            if(key == 'g-recaptcha-response') {
                                $('#contact-form-alert').show();
                                $('#contact-form-alert div').append('<p><i class="fa fa-angle-right fa-xs"></i> '+ value +'</p>');
                            }
                            else {
                                $('#contact-form [name=' + key +']').after('<span class="text-danger">'+ value +'</span>');
                            }
                        });
                    }
                },
                error : function(data) {
                    ajaxSubmitErrorCompleteActions('contact-form', 'contact-form-alert', 'error');
                },
                complete : function (data) {
                    if (window.grecaptcha) {
                        grecaptcha.reset();
                    }
                    // $(window).scrollTop(0);
                }
            });
            return false;
        }
    });

  // Handles the booking form in the bottom of page.
    var requestForm = $('#request-contact-form').validate({
        errorElement: 'span',
        errorClass: 'text-danger',
        ignore: [],
        //focusInvalid: false,
        rules: {
            ...contactFormValRule,
            rr_hiddenRecaptcha:{required:true}
        },
      highlight: function (element) {
        console.log(element)
            $(element).removeClass('valid').addClass('is-invalid');
        },
        unhighlight: function(element) {
            $(element).removeClass('is-invalid').addClass('valid');
        },
        success: function(label, element) {
            $(element).removeClass('is-invalid');
            label.remove();
        },
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        submitHandler: function(form) {
            ajaxSubmitErrorCompleteActions('request-contact-form', 'request-form-alert');
            $.ajax({
                type     : 'POST',
                url      : $('#request-contact-form').attr('action'),
                data     : $('#request-contact-form').serialize(),
                dataType : 'json',
                encode   : true,
                success  : function(data) {
                    ajaxSubmitErrorCompleteActions('request-contact-form', 'request-form-alert', 'success');
                    if(data.success){
                        window.location.href = base_url + 'contact-thankyou';
                    } else {
                        $.each(data.message, function(key, value) {
                            $('#request-contact-form [name=' + key + ']').addClass('is-invalid');
                            if(key == 'g-recaptcha-response') {
                                $('#request-form-alert').show();
                                $('#request-form-alert div').append('<p><i class="fa fa-angle-right fa-xs"></i> '+ value +'</p>');
                            }
                            else {
                                $('#request-contact-form [name=' + key +']').after('<span class="text-danger">'+ value +'</span>');
                            }
                        });
                    }
                },
                error : function(data) {
                    ajaxSubmitErrorCompleteActions('request-contact-form', 'request-form-alert', 'error');
                },
                complete : function (data) {
                    if (window.grecaptcha) { grecaptcha.reset();}
                    // $(window).scrollTop(0);
                }
            });
            return false;
        }
    });

  //handles the booking form modal~
  $('#request-form-modal').validate({
    errorElement: 'span',
    errorClass: 'text-danger',
    ignore: [],
    //focusInvalid: false,
    rules: {
      ...contactFormValRule,
      rr_ModalhiddenRecaptcha: { required: true }
    },
    highlight: function (element) {
      console.log(element)
      $(element).removeClass('valid').addClass('is-invalid');
    },
    unhighlight: function (element) {
      $(element).removeClass('is-invalid').addClass('valid');
    },
    success: function (label, element) {
      $(element).removeClass('is-invalid');
      label.remove();
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element);
    },
    submitHandler: function (form) {
      ajaxSubmitErrorCompleteActions('request-form-modal', 'request-form-alert');
      $.ajax({
        type: 'POST',
        url: $('#request-form-modal').attr('action'),
        data: $('#request-form-modal').serialize(),
        dataType: 'json',
        encode: true,
        success: function (data) {
          ajaxSubmitErrorCompleteActions('request-form-modal', 'request-form-alert', 'success');
          if (data.success) {
            window.location.href = base_url + 'contact-thankyou';
          } else {
            $.each(data.message, function (key, value) {
              $('#request-form-modal [name=' + key + ']').addClass('is-invalid');
              if (key == 'g-recaptcha-response') {
                $('#request-form-alert').show();
                $('#request-form-alert div').append('<p><i class="fa fa-angle-right fa-xs"></i> ' + value + '</p>');
              }
              else {
                $('#request-form-modal [name=' + key + ']').after('<span class="text-danger">' + value + '</span>');
              }
            });
          }
        },
        error: function (data) {
          ajaxSubmitErrorCompleteActions('request-form-modal', 'request-form-alert', 'error');
        },
        complete: function (data) {
          if (window.grecaptcha) { grecaptcha.reset(); }
          // $(window).scrollTop(0);
        }
      });
      return false;
    }
  });

});


$(document).ready(function() {
  $("input[type=number]").on("keypress keyup blur",function (event) {
    $(this).val($(this).val().replace(/[^\d].+/, ""));
    if (event.keyCode != 9 && event.keyCode != 8 && (event.which < 48 || event.which > 57)) {
      event.preventDefault();
    }
  });

  if ($("#home-search").length) {
    $("#home-search").autocomplete({
        source: function source(request, response) {
            $.ajax({
                url: GLOBAL_SEARCH_URL + '/quick',
                data: {
                    search: $.trim(request.term),
                    _site: window.atob(SITEID)
                },
                type: 'POST',
                success: function success(res) {
                    if (res) {
                        response(res);
                        var see_more = '<li class="list-group-item see-more-list"><div class="row"><div id="favorites" class=""><div class=""> <i class="fa fa-list" aria-hidden="true"></i> <b> See more</b></div></div></div></li>';
                        if (res[0].total.value > 5) {
                            $('.ui-autocomplete').append(see_more);
                        }
                    }
                }
            });
        },
        open: function( event, ui ) {
            $('li.list-section').removeClass('ui-menu-divider ui-widget-content');
            if ($('li.ui-menu-item').length) {
                $('li.ui-menu-item').removeClass('ui-menu-item');
            } else {
                $('.ui-menu.ui-autocomplete').hide();
            }
        },
        focus: function focus(event, ui) {
            //$( "#search" ).val( ui.item.title ); // uncomment this line if you want to select value to search box
            return false;
        },
        select: function select(event, ui) {
            window.location.href = ui.item.url;
        } }).data("ui-autocomplete")._renderItem = function (ul, item) {

            var innerHtml = '';
            if (item.hits) {
              var itemsList = item.hits;

              var outerHtml = '';
              var itemIndex = '';
              innerHtml += '<ol class="search-list">';
              itemsList.forEach(function(itemDetails, indx) {
                  var itemInfo = itemDetails._source;

                  if (item.index == 'celebrities') {
                      innerHtml += '<li class="celebrity_li" data-url="' + itemInfo.url + '"><div class="row"> <div class="col-2"> <div class="media-left media-middle"> <img class="li-img-responsive media-object img-circle" src="' + itemInfo.image + '"> </div></div><div class="col-10"> <a href="' + itemInfo.url + '"> <span class="celebrity_name"> ' + itemInfo.title + ' </span> </a> </div></div></li>';
                      itemIndex = 'Speakers';
                  } else if (item.index == 'categories') {
                      innerHtml += '<li class="celebrity_li categories-list" data-url="' + base_url + 'category/' + itemInfo.slug + '"><div class="row"><div class="col-12"> <a href="' + base_url + 'category/' + itemInfo.slug + '"> <span class="celebrity_name"> ' + itemInfo.name + ' </span> </a> </div></div></li>';
                      itemIndex = 'Categories';
                  } else if (item.index == 'lists') {
                      innerHtml += '<li class="celebrity_li" data-url="' + base_url + 'speaker-list/' + itemInfo.slug + '"><div class="row"><div class="col-12"> <a href="' + base_url + 'speaker-list/' + itemInfo.slug + '"> <span class="celebrity_name"> ' + itemInfo.name + ' </span> </a> </div></div></li>';
                      itemIndex = 'Lists';
                  }

              });
              innerHtml += '</ol>';
              var listTitle = '';
              if (itemIndex) {
                listTitle = '<div class="search-section-title">' + itemIndex + '</div>';
              }

              outerHtml = listTitle + innerHtml;
              return $("<li class='list-section'></li>").append(outerHtml).appendTo(ul);
          } else if(item ) {
              var itemsList = item;
              var outerHtml = '';
              var itemIndex = '';
              innerHtml += '<ol class="search-list">';

              innerHtml += '<li class="celebrity_li" data-url="' + itemsList.url + '"><div class="row"> <div class="col-2"> <div class="media-left media-middle"> <img class="li-img-responsive media-object img-circle" src="' + itemsList.image + '"> </div></div><div class="col-10"> <a href="' + itemsList.url + '"> <span class="celebrity_name"> ' + itemsList.title + ' </span> </a> </div></div></li>';
              itemIndex = 'Speakers';

              innerHtml += '</ol>';
              var listTitle = '';
              if (itemIndex) {
                listTitle = '<div class="search-section-title">' + itemIndex + '</div>';
              }
              outerHtml = listTitle + innerHtml;
              return $("<li class='list-section'></li>").append(outerHtml).appendTo(ul);
          }
            return $("").appendTo(ul);
    };
  }

  $('body').on('keypress', '#home-search', function (event) {
    var keycode = event.keyCode ? event.keyCode : event.which;
    if (keycode == '13') {
        var homeSearch = $(this).val().trim();
        if (homeSearch != "") {
            location.href = base_url + "talent?search=" + homeSearch;
        }
    }
  });

  $("body").on("click", ".see-more-list, .search-button", function () {
    if ($(".search-box")) {
        var homeSearch = $(".search-box").val() ? $(".search-box").val().trim() : '';
        if (homeSearch != "") {
            location.href = base_url + "talent?search=" + homeSearch;
        }
    }
  });

  $("body").on("click", ".search-list .celebrity_li", function (event) {
    event.preventDefault();
    var dataUrl = $(this).data('url');
    if (dataUrl && dataUrl != 'undefined') {
        location.href = dataUrl;
    }
  });

  if($("#landscape_search").length) {
    $("#landscape_search").autocomplete({
      source: function(request, response) {
        $.ajax({
          url: '/get-celebrites',
          data: {
            search: request.term,
          },
          success: function(data) {
            response(data);
            var see_more = '<li class="list-group-item see-more"><div class="row"><div id="favorites" class=""><div class=""> <i class="fa fa-list" aria-hidden="true"></i> <b> See more</b></div></div></div></li>';
            if (data.length && data[0]['total_items'] > 5) {
              $('.ui-autocomplete').append(see_more);
            }
          }
        })
      },
      focus: function(event, ui) {
        //$( "#search" ).val( ui.item.title ); // uncomment this line if you want to select value to search box
        return false;
      },
      select: function(event, ui) {
        window.location.href = ui.item.url;
      }
    }).data("ui-autocomplete")._renderItem = function(ul, item) {
      var inner_html = '<div class="row"> <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3"> <div class="media-left media-middle"> <img class="li-img-responsive media-object img-circle" src="' + item.image + '"> </div></div><div class="col-lg-9 col-md-9 col-sm-9 col-xs-9"> <a href="' + item.url + '"> <span class="celebrity_name"> ' + item.title + ' </span> </a> </div></div>';
      return $("<li  class='celebrity_li list-group-item' ></li>").data("item.autocomplete", item).append(inner_html).appendTo(ul);
    };
  }

  if(localStorage.our_service) {
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: $('#services').offset().top,
      }, 500);
      localStorage.removeItem('our_service');
    },500);
  }

  $("body").on("click", '.mobile_services',function(e){
    var targetRoute = $(this).data("page");
    var isMobile = window.mobileAndTabletcheck();
    if(targetRoute != "home" && !isMobile){
      e.stopPropagation();
      localStorage.setItem('our_service', true);
      location.href= '/';
    }
    else if(isMobile) {
      e.preventDefault();
      $(this).parent().toggleClass('active');
    }
  });
});

window.processLazyLoadImages = function() {
  setTimeout(function() {
    [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
      img.setAttribute('src', img.getAttribute('data-src'));
      img.onload = function() {
        img.removeAttribute('data-src');
      };
    });
  }, 1000);
};

$(function () {
  window.processLazyLoadImages();
});



// WEBPACK FOOTER //
// ./public/themes/speakerbookingagency/scripts/script-blade.js